import { StarTwoTone, CalendarTwoTone, FolderOutlined, DeleteOutlined, ClockCircleOutlined, FormOutlined, DatabaseOutlined, BellTwoTone, SearchOutlined } from '@ant-design/icons'
import { InboxIcon, MailUnreadIcon, SendPlaneFillIcon } from '@/components/Icons'

const EmailDirTypeIcons = {
  'search': { component: SearchOutlined, color: '', className: 'text-blue-600' },
  'star': { component: StarTwoTone, color: '', className: '' },
  'calendar': { component: CalendarTwoTone, color: '', className: '' },
  'reminder': { component: BellTwoTone, color: '', className: '' },
  0: { component: FolderOutlined, color: '#ffe78f', className: 'text-blue-500' },
  1: { component: FolderOutlined, color: '#ffe78f', className: 'text-blue-500' },
  3: { component: InboxIcon, color: '', className: 'text-indigo-500' },
  17: { component: InboxIcon, color: '', className: 'text-indigo-500' },
  11: { component: MailUnreadIcon, color: '', className: 'text-indigo-500' },
  4: { component: SendPlaneFillIcon, color: '', className: 'text-primary' },
  2: { component: ClockCircleOutlined, color: '', className: 'text-yellow-500' },
  5: { component: FormOutlined, color: '', className: 'text-blue-500' },
  7: { component: DeleteOutlined, color: '', className: 'text-red-500' },
  // '3': { component: MailCheckIcon, color: '', className: 'text-yellow-600' },
  12: { component: DatabaseOutlined, color: '', className: 'text-blue-600' },
  13: { component: () => null, color: '', className: '' },
  14: { component: () => '❗', color: '', className: '' }, // 240002 较重要/高品牌价值客户
  15: { component: () => '❣️', color: '', className: '' }, // 240003 很重要/高订单价值客户
}

export const MailboxDirIcon = ({ type }) => {
  const Icon = EmailDirTypeIcons[type || '13']?.component || EmailDirTypeIcons['13'].component
  const className = EmailDirTypeIcons[type || '13']?.className || EmailDirTypeIcons['13'].className
  return <Icon className={className} />
}

export default MailboxDirIcon
